// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__2PLM0","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__3umIv"};